import { useState } from "react";
import { Form } from "../../Components/form";
import Button from "../../Components/button";
import { useNavigationContext } from "../../Context/NavigationContext";
import { useGlobalContext } from "../../Context/GlobalContext";
import { Logo } from "../../Components/logo";

const ForgotPassword = () => {
    const { changeLandingView } = useNavigationContext();
    const { dbManager } = useGlobalContext();
    
    const [email, setEmail] = useState<string>('');
    const [emailSent, setEmailSent] = useState<boolean>(false);

    const handleSubmit = async () => {
        dbManager.request('/user/passwordReset', 'POST', {email})
        setEmailSent(true);
    }

    return (
        <div className="forgot-password-wrapper" style={{width: '40%', margin: 'auto', marginTop: '3vh'}}>
            <Logo />
            {!emailSent ? <Form 
                fields={[
                    { label: 'Email', type: 'text', placeholder: 'hello@neo.com', setValue: setEmail, value: email },
                ]}
                submit={handleSubmit}   
                buttonText="Request New Password"
            /> :
            <div className="forgot-password-form">
                <p style={{ maxWidth: '300px', margin: '30px auto' }}>
                    SUCCESS. WE'VE SENT YOU AN EMAIL WITH A LINK TO RESET YOUR PASSWORD. 
                    IF YOU DON'T SEE IT, CHECK YOUR SPAM OR JUNK FOLDER.
                </p>
                <div className="button-wrapper">
                    <Button 
                        text="LOGIN"
                        onClick={() => changeLandingView('login')}
                        className="padding-large"
                    />
                </div>
            </div>}
        </div>
    );
}

export default ForgotPassword;